const ENV = "HARC"

let tile_server;
let tile_server_query;
let socket_url;
let dance4water_host;
let query_url;
let query_url_immediate;
let help_url;

if (ENV === "DEV") {
    tile_server = "http://127.0.0.1:4321/";
    tile_server_query = "http://127.0.0.1:4321/query3";
    dance4water_host = "http://127.0.0.1:8181/api";
    socket_url = "http://127.0.0.1:8182/";
    query_url = "http://127.0.0.1:6997/resultsdb/";

} else if (ENV === "REMOTE_DEV") {
    tile_server = "https://development-tiles.dance4water.org/";
    tile_server_query = "https://development-tiles.dance4water.org/query3";
    dance4water_host = "https://development-api.dance4water.org/api";
    socket_url = "https://development-ws.dance4water.org";
    query_url = "https://staging-sql.dance4water.org/resultsdb/";
    help_url = "https://doc-development.wsc-scenario.org.au/";
} else if (ENV === "STAGING") {
    tile_server = "https://staging-tiles.dance4water.org/";
    tile_server_query = "https://staging-tiles.dance4water.org/query3";
    dance4water_host = "https://staging-api.dance4water.org/api";
    socket_url = "https://staging-ws.dance4water.org";
    query_url = "https://staging-sql.dance4water.org/resultsdb/";
    help_url = "https://doc-staging.wsc-scenario.org.au/";
} else if (ENV === "STABLE") {
    tile_server = "https://stable-tiles.dance4water.org/";
    tile_server_query = "https://stable-tiles.dance4water.org/query3";
    dance4water_host = "https://stable-api.dance4water.org/api";
    socket_url = "https://stable-ws.dance4water.org";
    query_url = "https://stable-sql.dance4water.org/resultsdb/";
    help_url = "https://doc-stable.wsc-scenario.org.au/";
}else if (ENV === "HARC") {
    tile_server = "https://stable-tiles.harc-dev.com.au/";
    tile_server_query = "https://stable-tiles.harc-dev.com.au/query3";
    dance4water_host = "https://stable-api.harc-dev.com.au/api";
    socket_url = "https://stable-ws.harc-dev.com.au";
    query_url = "https://stable-sql.harc-dev.com.au/resultsdb/";
    help_url = "https://doc-stable.wsc-scenario.org.au/";
}

const case_study_area_limit = 40000;

export {
    tile_server,
    socket_url,
    dance4water_host,
    query_url,
    query_url_immediate,
    tile_server_query,
    help_url,
    case_study_area_limit,
};
